import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import { TitleSmallText } from '@prisjakt/ui/text/variants';

export const USER_AVATAR_SIZE = 32;

type NameProps = {
  showSubtitle: boolean;
};

export const Name = styled(TitleSmallText)<NameProps>`
  max-width: 156px;
  grid-area: ${p => (p.showSubtitle ? '1 / 2 / 2 / 3' : '1 / 2 / 3 / 3')};
  align-self: center;
`;

export const Avatar = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  align-self: center;
`;

type ExpertProps = {
  $overlap: number;
  $index: number;
};

export const Expert = styled.div<ExpertProps>`
  display: grid;
  grid-template-columns: ${USER_AVATAR_SIZE}px 1fr;
  grid-template-rows: auto auto;
  column-gap: ${layout.spacing.xSmall};
  transform: ${p =>
    p.$overlap
      ? `translateX(-${(USER_AVATAR_SIZE * p.$overlap) / 2}px)`
      : 'none'};
  z-index: ${p => p.$index};

  p {
    margin: 0;
  }
`;

export const Container = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: ${USER_AVATAR_SIZE}px;

  &[href]:hover {
    ${Name} {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
`;
